module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/install-187.vue");


//////////////////
// WEBPACK FOOTER
// ./en/vux-loader/install.md
// module id = 625
// module chunks = 431